import React from "react";
import MainSubtitle from "../components/MainSubtitle";
import Appetizers from "../components/MenuItems/Appetizers";
import Soups from "../components/MenuItems/Soups";
import Pancakes from "../components/MenuItems/Pancakes";
import MainDishes from "../components/MenuItems/MainDishes";
import Fishes from "../components/MenuItems/Fishes";
import HomelyDishes from "../components/MenuItems/HomelyDishes";
import Salads from "../components/MenuItems/Salads";
import Pastas_PotatoCakes_Dumplings_Burgers from "../components/MenuItems/Pastas_PotatoCakes_Dumplings_Burgers";
import Addons from "../components/MenuItems/Addons";
import Boards from "../components/MenuItems/Boards";
import Pizzas from "../components/MenuItems/Pizzas";
import Desserts from "../components/MenuItems/Desserts";
import BeerPoured from "../components/MenuItems/Beer_poured";
import DrinksNonAlc from "../components/MenuItems/DrinksNonAlc";
import Vodka_BeerBottled from "../components/MenuItems/Vodka_BeerBottled";
import Alcohols from "../components/MenuItems/Alcohols";
import Shots from "../components/MenuItems/Shots";
import DrinksAlc from "../components/MenuItems/DrinksAlc";
import Coctails from "../components/MenuItems/Coctails";
import Allergens from "../components/MenuItems/Allergens";

function Menu() {

    return (
        <main>
            <MainSubtitle />
            <Appetizers />
            <Soups />
            <Pancakes />
            <MainDishes />
            <Fishes />
            <HomelyDishes />
            <Salads />
            <Pastas_PotatoCakes_Dumplings_Burgers />
            <Addons />
            <Boards />
            <Desserts />
            <Pizzas />
            <DrinksNonAlc />
            <BeerPoured />
            <Vodka_BeerBottled />
            <Alcohols />
            <Shots />
            <DrinksAlc />
            <Coctails />
            <Allergens />
        </main>
    )
}

export default Menu;